import React from "react";

import { ReactComponent as PHONE } from "../build/images/callchat-new.svg";
import { ReactComponent as FACEBOOK } from "../build/images/facebook_new.svg";
import { ReactComponent as WHATSAPP } from "../build/images/whatsapp_new.svg";
import { ReactComponent as TELEGRAM } from "../build/images/telegram-new.svg";
import { ReactComponent as GOOGLEGBM } from "../build/images/googlegbm-new.svg";
import { ReactComponent as WEBCHAT } from "../build/images/webchat-new.svg";
import { ReactComponent as INSTAGRAM } from "../build/images/instagram_new.svg";
import { ReactComponent as EMAIL } from "../build/images/email-new.svg";
import { ReactComponent as TEAMS } from "../build/images/channelsNew/teamsBig.svg";
import { ReactComponent as SMS } from "../build/images/sms-new.svg";
import { ReactComponent as WHATSAPPVOICE } from "../build/images/whatsapp_voice.svg";

export function getIconByChannel(mediaId) {
  const integerId = parseInt(mediaId);
  switch (integerId) {
    case 1:
      return <PHONE />;
    case 2:
      return <WEBCHAT />;
    case 3:
      return <EMAIL />;
    case 4:
      return <FACEBOOK />;
    case 5:
      return <WHATSAPP />;
    case 6:
      return <INSTAGRAM />;
    case 8:
      return <TELEGRAM />;
    case 11:
      return <GOOGLEGBM />;
    case 12:
      return <SMS />;
    case 15:
      return <TEAMS />;
    case 16:
      return <WHATSAPPVOICE />;
    default:
      break;
  }
}
